import { Container, Typography } from "@mui/material"


const ReportUnderstanding = () => {
    return (
    <Container maxWidth="xl">
        <Typography variant='subtitle1' sx={{margin:"20px 0px"}}>The Kingdom Calling Assessment explores three layers of your God-designed leadership:</Typography>
        <Typography variant='subtitle1' sx={{margin:"20px 0px"}}><span style={{fontWeight:"bold"}}>1. Your Sphere</span> – Where God has designed you to show up and lead.</Typography>
        <Typography variant='subtitle1' sx={{margin:"20px 0px"}}><span style={{fontWeight:"bold"}}>2. Your Five-Fold Personality</span> – How Jesus expresses His heart through you (apostolic, prophetic, evangelistic, shepherd, or teacher personalities).</Typography>
        <Typography variant='subtitle1' sx={{margin:"20px 0px"}}><span style={{fontWeight:"bold"}}>3. Your Biblical DNA</span> – The values, instincts, and anointing that shape your Kingdom expression and impact.</Typography>
        <Typography variant='subtitle1' sx={{margin:"20px 0px"}}>These are not labels to wear, but lenses to look through — helping you interpret your life, leadership, and legacy with clarity and confidence.</Typography>
    </Container>
    )
}

export default ReportUnderstanding